import "./index.css"

export default function PopupHeader ({textos}) {
    return (
        <div className="p-2 top-0 left-0 fixed bg-slate-800 w-full z-10 scroller">
            <div className="scroll_container flex-row">
                {
                    textos.map((texto) => {
                        return(
                            <h1 className="text-blue-300 font-semibold text-2xl scroll_item">
                                {texto}
                            </h1>
                        )
                    })
                }
                <h1 className="text-blue-300 font-semibold text-2xl scroll_item">
                    Ao terminar de usar o serviço desejado, lembre-se de clicar no botão Encerrar para finalizar o atendimento.
                </h1>
                <h1 className="text-blue-300 font-semibold text-2xl scroll_item">
                    Caso não haja ação do usuário neste terminal por 60 segundos, o serviço será encerrado automaticamente.
                </h1>
            </div>
        </div>
    )
}
